<template>
  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
          <span>Adders</span>
        </span>
        <span class="sba-collection-context">Principal Search Workspace</span>
      </div>
    </div>
  </nav>

  <div class="sba-collection-page-surface is-workbench adder-secondary-surface">
    <div class="container">
      <LoadingDiv v-if="!isReady" />

      <template v-else>
        <div class="adder-page-surface sba-slide-in sba-slide-in-children">
          <div class="adder-review-head">
            <div class="adder-title-block">
              <label class="active teal-text">Principal Search</label>
              <h5>Find Active Principals</h5>
              <p>Search active principals by name or enrollee ID, then open the principal workspace for permitted account actions.</p>
            </div>
            <span class="adder-scope-chip">
              Active cover
              <em>Current paid or grace invoice period</em>
            </span>
          </div>

          <div class="adder-search-card">
            <form autocomplete="off">
              <div class="input-field">
                <input
                  type="search"
                  v-model="searchItem"
                  placeholder="Search by name or enrollee ID"
                  autocomplete="off"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                />
                <label class="label-icon" for="search"><i class="material-icons">search</i></label>
                <i
                  class="material-icons"
                  @click="handleClearSearch"
                  v-if="searchItem || enrollees.length"
                >
                  clear
                </i>
              </div>
            </form>
          </div>

          <div class="adder-search-status" v-if="searchItem">
            <div>
              <span>Search active</span>
              <strong>{{ searchItem }}</strong>
            </div>
            <button type="button" @click="handleClearSearch" title="clear search">
              <i class="material-icons">close</i>
            </button>
          </div>

          <LoadingDiv v-if="isLoading" />

          <template v-else>
            <ActiveHoldDiv
              :authLevel="authLevel"
              :cat="cat"
              :enrollees="enrollees"
              :displayType="displayType"
              @reset="handleReset"
              v-if="displayType == 'a' || displayType == 'h'"
            />

            <div class="adder-empty-state" v-if="!enrollees.length">
              <i class="material-icons">manage_search</i>
              <h6>{{ searchItem ? "No matching principal found" : "Search for a principal" }}</h6>
              <p>{{ searchItem ? "Try another name or enrollee ID." : "Enter a name or enrollee ID to find active covered principals." }}</p>
            </div>

            <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUpdated, ref, watchEffect } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import getItems from "@/composables/getItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import ActiveHoldDiv from "@/components/client/extras/PrincipalActiveHoldClientComponent.vue";
import M from "materialize-css";

export default {
  name: "AdderHome",
  components: {
    SubHeading,
    LoadingDiv,
    PaginationDiv,
    ActiveHoldDiv,
  },
  setup() {
    const authLevel = 1;
    const cat = "hmo";
    const displayType = "a";
    const response = ref(null);
    const isReady = ref(true);
    const isSubmitting = ref(false);
    const isLoading = ref(false);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const searchItem = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const { scrollToModuleTop } = useModuleNavigation();

    onMounted(() => {
      document.title = "Adders";
    });

    onMounted(() => {
      tabs.value.push({ id: 1, name: "Adders", title: "All", icon: null, url: "adder", hash: null });
      currTab.value = tabs.value.find((x) => x.id === 1);
      home.value = currTab.value;
    });

    const handleActive = () => {
      handleClearSearch();
      scrollToModuleTop();
    };

    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        isReady.value = true;
        isLoading.value = false;
      })();
    };

    onMounted(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

    onUpdated(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

    const handleClearSearch = () => {
      searchItem.value = null;
      response.value = null;
      isLoading.value = false;
    };

    const handlePage = (page) => {
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`);
    };

    const handleReset = (val) => {
      let idx;

      if (val) {
        response.value.data.forEach((x, y) => {
          if (x.id == val.id) {
            idx = y;
          }
        });

        response.value.data[idx] = val;
      }
    };

    watchEffect(() => {
      if (searchItem.value && isReady.value) {
        isLoading.value = true;
        currUrl.value = "operator/adders/principlal/search";
        currHook.value = `?q=${searchItem.value}&`;
        getItemsFromApi(`${currUrl.value}?q=${searchItem.value}`);
      }
    });

    const enrollees = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    return {
      authLevel,
      cat,
      displayType,
      handleActive,
      handlePage,
      handleClearSearch,
      handleReset,
      home,
      currTab,
      tabs,
      isReady,
      isSubmitting,
      isLoading,
      error,
      searchItem,
      allPages,
      enrollees,
    };
  },
};
</script>

<style scoped>
.adder-page-surface {
  margin-top: 0;
  position: relative;
  z-index: 1;
}

.adder-secondary-surface {
  min-height: calc(100vh - 260px);
}

.adder-review-head {
  align-items: flex-end;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.adder-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.adder-review-head > * {
  position: relative;
  z-index: 2;
}

.adder-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.adder-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 720px;
}

.adder-scope-chip {
  background: #e0f2f1;
  border: 1px solid #b2dfdb;
  border-radius: 18px;
  color: #00695c;
  display: inline-flex;
  flex-direction: column;
  flex-shrink: 0;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.3;
  padding: 7px 12px;
  text-align: right;
}

.adder-scope-chip em {
  color: #455a64;
  font-size: 0.76rem;
  font-style: normal;
}

.adder-search-card {
  background: #f7f7f7;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 14px 26px -24px rgba(38, 50, 56, 0.74);
  margin-bottom: 16px;
  padding: 12px 16px;
}

.adder-search-card:has(+ .adder-search-status) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.adder-search-card form,
.adder-search-card .input-field {
  margin: 0;
}

.adder-search-card .input-field {
  position: relative;
}

.adder-search-card input[type="search"] {
  background: #ffffff;
  border-bottom: none !important;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none !important;
  color: #263238;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  margin: 0;
  padding-left: 46px;
  padding-right: 42px;
  width: 100%;
}

.adder-search-card .label-icon {
  align-items: center;
  display: flex;
  height: 48px;
  left: 10px;
  line-height: 48px;
  position: absolute;
  top: 0;
}

.adder-search-card .material-icons {
  color: #00897b;
  height: 48px;
  line-height: 48px;
}

.adder-search-card .input-field > i {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  line-height: 48px;
  position: absolute;
  right: 10px;
  top: 0;
}

.adder-search-status {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 16px 28px -24px rgba(38, 50, 56, 0.72);
  color: #263238;
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
  padding: 12px 14px 12px 16px;
}

.adder-search-status span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.adder-search-status strong {
  color: #263238;
  font-size: 0.98rem;
}

.adder-search-status button {
  align-items: center;
  background: #f7f7f7;
  border: 1px solid #e1e8eb;
  border-radius: 50%;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.adder-search-status button i {
  font-size: 18px;
}

.adder-empty-state {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  color: #607d8b;
  padding: 34px 20px;
  text-align: center;
}

.adder-empty-state i {
  color: #90a4ae;
  font-size: 42px;
}

.adder-empty-state h6 {
  color: #263238;
  font-weight: 700;
  margin: 8px 0 0;
}

.adder-empty-state p {
  margin: 7px 0 0;
}

@media only screen and (max-width: 992px) {
  .adder-review-head {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media only screen and (max-width: 600px) {
  .adder-secondary-surface {
    padding-bottom: 34px;
  }

  .adder-review-head {
    gap: 14px;
    padding: 20px;
  }

  .adder-title-block h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .adder-title-block p {
    font-size: 0.95rem;
  }

  .adder-scope-chip {
    text-align: left;
    width: 100%;
  }

  .adder-search-card {
    padding: 10px;
  }

  .adder-search-status {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .adder-search-status button {
    border-radius: 6px;
    width: 100%;
  }
}
</style>
